import React, { Component } from 'react';
import { ListGroupItem, ListGroup } from 'react-bootstrap';

export default class ReleaseInfoContent extends Component {
  render() {
    const { releaseInfo } = this.props;

    return (
      <ListGroup fill>
        { releaseInfo.releaseFeatures.map(feature => {
          return (
            <ListGroupItem key={feature.releaseFeatureId} header={feature.title} className='item-release_info'>      
              {feature.description}
            </ListGroupItem>
          );
        })}
      </ListGroup>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/common/release-info-content.js